import {VetproviehElement} from './vetprovieh-element';
import {WebComponent} from '../decorators';
import {VetproviehBasicRepeat} from './vetprovieh-basic-repeat';

 // eslint-disable-next-line new-cap
 @WebComponent({
   template: VetproviehElement.template + `<div id="listElements"></div>`,
   tag: 'vp-repeat',
 })
/**
 * Repeats Template Element. Amount is set by the amount of objects
 * inside
 */
export class VetproviehRepeat extends VetproviehBasicRepeat {
}
